import React from 'react';
import { USER_TIERS } from '../../constants';

interface TierBadgeProps {
    tier: number;
    showName?: boolean;
    className?: string;
}

const TierBadge: React.FC<TierBadgeProps> = ({ tier, showName = false, className = '' }) => {
    const tierData = USER_TIERS.find(t => t.level === tier);
    if (!tierData || tier === 0) return null;

    return (
        <div className={`inline-flex items-center gap-1.5 ${className}`}>
            {/* Small minimalist shape (Diamond/Hexagon inspired) */}
            <div
                className="w-3.5 h-3.5 rotate-45 rounded-[2px] shadow-[0_0_10px_rgba(0,0,0,0.3)]"
                style={{
                    backgroundColor: tierData.color,
                    boxShadow: `0 0 8px ${tierData.color}44`
                }}
            />
            {showName && (
                <span
                    className="text-2xs font-black uppercase tracking-widest"
                    style={{ color: tierData.color }}
                >
                    {tierData.name}
                </span>
            )}
        </div>
    );
};

export default TierBadge;
